export const DEFAULT_THRESHOLDS = {
    highFloor: 5.0,
    mediumFloor: 3.0,
};
export function costOfDelay(scores) {
    const { businessValue, timeCriticality, riskOpportunity } = scores;
    if (businessValue == null || timeCriticality == null || riskOpportunity == null)
        return null;
    return businessValue + timeCriticality + riskOpportunity;
}
export function wsjf(scores) {
    const cod = costOfDelay(scores);
    const size = scores.jobSize;
    // size is typed `Fib | null`; the `size === 0` branch is a runtime safety net
    // even though Fib excludes 0. The cast keeps the comparison explicit without a
    // ts-ignore directive.
    if (cod == null || size == null || size === 0)
        return null;
    return cod / size;
}
export function priorityBand(wsjfValue, thresholds) {
    if (wsjfValue == null)
        return null;
    if (wsjfValue >= thresholds.highFloor)
        return 'High';
    if (wsjfValue >= thresholds.mediumFloor)
        return 'Medium';
    return 'Low';
}
